// generated from 5 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const heapCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("heap_cohort_filter"),
  comparison_key: z.literal("7"),
  display_name: z.string(),
  value: z.object({
    id: z.string(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
